export const forecastingEditTableAlert = {
  background: "#323232",
  boxShadow:
    "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12)",
  borderRadius: "4px",
  position: "absolute",
  zIndex: "2",
  marginLeft: "auto",
  marginRight: "auto",
  left: "0",
  right: "0",
  bottom: "43px",
  display: "flex",
  justifyContent: "center",
  width: "fit-content",
};

export const forecastingEditTableSelect = {
  boxShadow: "none",
  width: "400px",
  ".MuiOutlinedInput-notchedOutline": { border: 0 },
};

export const forecastingEditTableDownloadingProgress = {
  position: "absolute",
  bottom: "0",
  right: 0,
  cursor: "pointer",
  zIndex: 4,
};

export const forecastingEditTableDownload = {
  position: "absolute",
  bottom: "0",
  right: 0,
  cursor: "pointer",
  zIndex: 2,
};

export const shipmentTableSelect = {
  boxShadow: "none",
  flex: 1,
  ".MuiOutlinedInput-notchedOutline": { border: 0 },
};

export const textField = { background: "#cddef0" };

export const alert = {
  background: "#323232",
  boxShadow:
    "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12)",
  borderRadius: "4px",
  position: "absolute",
  zIndex: "2",
  marginLeft: "auto",
  marginRight: "auto",
  left: "0",
  right: "0",
  bottom: "43px",
  display: "flex",
  justifyContent: "center",
  width: "fit-content",
};

export const shipmentExport = {
  position: "absolute",
  bottom: "0",
  right: 0,
  cursor: "pointer",
  zIndex: 2,
};

export const alertText = {
  color: "white",
  fontFamily: "Lato",
  margin: "0 12px",
};

export const tooltipStyle = { fontWeight: "bold" };

export const columnValue = {
  textOverflow: "ellipsis",
  flex: 1,
  display: "block",
  overflow: "hidden",
};

export const shipmentTableSelectText = {
  marginLeft: "15px",
  fontSize: "14px",
  fontWeight: 400,
};

export const noteStyle = {
  fontSize: "16px",
  fontWeight: 400,
  color: "grey",
  fontFamily: "Lato",
  marginLeft: "10px",
  marginBottom: "10px",
}

export const commonHeaderStyle = {
  fontSize: "small",
  textOverflow: "clip",
  lineHeight: 1,
  paddingTop: "0.15rem",
  fontWeight: "bold",
}

export const catalogTrackerTableStyle = {
  position: "relative",
  borderTop: "5px solid #002B49",
  borderRadius: "8px",
  marginTop: "40px",
  width: "100%",
  flexGrow: 1,
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  paddingBottom: "20px",
}

export const catalogTrackerStyle = { display: "flex", minHeight: 0, flexGrow: 1, width: "100%" }
